import React, { createContext, useReducer } from 'react';

const initialState = {
  prayerLists: [],
};

const AppContext = createContext(initialState);

const reducer = (state, action) => {
  switch (action.type) {
    case 'ADD_PRAYERS':
      const existing = state.prayerLists.find(({ id }) => id === action.id) || {
        prayers: [],
        categories: [],
      };
      var newPrayers = [...existing.prayers, ...action.prayers];
      var newCats = [...existing.categories, ...action.categories];
      return {
        ...state,
        prayerLists: [
          ...state.prayerLists.filter(({ id }) => id !== action.id),
          { id: action.id, prayers: newPrayers, categories: newCats },
        ],
      };
    default:
      return state;
  }
};

const AppProvider = ({ children }) => {
  const [appState, appDispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ appState, appDispatch }}>
      {children}
    </AppContext.Provider>
  );
};

const AppConsumer = AppContext.Consumer;

export { AppContext, AppProvider, AppConsumer };
